.root {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    100deg,
    rgba(231, 245, 255, 0.5) 1%,
    rgba(231, 245, 255, 1) 30%,
    rgba(231, 245, 255, 1) 70%,
    rgba(231, 245, 255, 0.5) 99%
  );
  border: 1px solid var(--blue-700);
  border-radius: 4px;
}

.source {
  max-width: 500px;
  text-align: center;
}
